import { join } from "lodash";
import * as React from "react";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { EmploymentDetail } from "../../../../../../Wrap/Models/Models/Customer/EmploymentDetail";
import { PersonalDetail } from "../../../../../../Wrap/Models/Models/Customer/PersonalDetail";
import { CustomerTaxResidencyModel } from "../../../../../../Wrap/Models/Models/Customer/Regulatory/CustomerTaxResidencyModel";
import { CountryCodeMap } from "../../../../../Shared/Entities/Maps/CountryCodeMap";
import { TitleMap } from "../../../../../Shared/Entities/Maps/TitleMap";
import { Typography } from "../../../../../Shared/Typography/Typography";
import { prepareTypography } from "../../Common/Review/ReviewParser";
import { GenderOptionsMap, Marital } from "../../NewBusinessWizard/Resource/Contents";
import { IndividualEmploymentStatusOptionsMap } from "../../NewQuoteWizard/Resource/Content";
import { fieldDefaultValue, getNationality } from "../Resource/CustomerMergeHelper";

interface IPersonalDetailsProps {
    pData: PersonalDetail;
    eData: EmploymentDetail;
    tData: Array<CustomerTaxResidencyModel>;
}

export const PersonalDetails = (props: IPersonalDetailsProps) => {
    const personalDetailsConfig = (
        pData: PersonalDetail,
        eData: EmploymentDetail,
        tData: Array<CustomerTaxResidencyModel>
    ) => {
        return [
            {
                title: "Title",
                data: fieldDefaultValue(TitleMap.getString(pData?.Title)),
            },
            {
                title: "First name(s)",
                data: fieldDefaultValue(pData.GivenName),
            },
            {
                title: "Surname",
                data: fieldDefaultValue(pData?.FamilyName),
            },
            {
                title: "Gender",
                data: fieldDefaultValue(GenderOptionsMap[pData?.Gender]),
            },
            {
                title: "Marital status",
                data: fieldDefaultValue(Marital.optionsMap[pData?.MaritalStatus]),
            },
            {
                title: "DOB",
                data: JsonDateParser.getFormatDate(pData?.DateOfBirth, "dd/MM/yyyy"),
            },
            {
                title: "Town of birth",
                data: fieldDefaultValue(pData?.TownOfBirth),
            },
            {
                title: "Country of nationality",
                data: fieldDefaultValue(join(getNationality(tData), ",")),
            },
            {
                title: "Country of birth",
                data: fieldDefaultValue(CountryCodeMap.getString(pData?.CountryOfBirth)),
            },
            {
                title: "Employment status",
                data: fieldDefaultValue(IndividualEmploymentStatusOptionsMap[eData?.IndividualEmploymentStatus]),
            },
        ];
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <h3>
                        <u>Customer details</u>
                    </h3>
                </div>
            </div>
            <Typography
                {...prepareTypography(personalDetailsConfig(props.pData, props.eData, props.tData), 1, "common")}
            />
        </>
    );
};
